export function injectable(WrappedClass) {
    return WrappedClass;
}
